
const getPercent = (data, targetName) => {
    const total = data.reduce((s, d) => s + d.value, 0);
    const target = data.find(d => d.key === targetName)?.value ?? 0;
    return Math.round((target / total) * 100);
};

const monthFormatter = (date) => {
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const monthNum = dateObj.getMonth();
    return `${months[monthNum]}\n${year}`;
}

// 只能用字串模板，請勿用ReactComponent，回傳直只接受String型別
const tooltipFormatter = ({ name, value, percent }) => {
    return `
		<strong>${name}</strong><br/>
		${value} 人（${Math.round(percent)}%）
	`;
};

/** ----------圓餅圖專用---------- */
const adaptPie = (names, values) => {
    return names.map((name, i) => ({
        name,
        value: values[i]
    }));

};

// const assignLevel = (data, config) => {
//     const sorted = [...data].sort((a, b) => a.value - b.value);
//     return sorted.map((item, i) => ({
//         ...item,
//         ...config[i],
//     }));
// };

/** ----------直線圖專用---------- */
const adaptBar = raw => {
    // raw: { xAxis: string[], data: string[] }
    const { xAxis, data: values } = raw;
    const axisLabels = xAxis;
    const data = values.flat(1).map(v => Number(v));
    const avg = Math.round(data.reduce((sum, v) => sum + v, 0) / data.length);
    return { axisLabels, data, avg };
};

export { getPercent, monthFormatter, tooltipFormatter, adaptPie, adaptBar };
